import Class from './c-loading-test';
import './c-loading-test@';

export default Class;